import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './index.css';
import 'leaflet/dist/leaflet.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getRecaptchaSiteKey } from './utils/config';
import { installAuthFetchInterceptor } from './utils/authFetchInterceptor';

if (typeof window !== 'undefined' && !(window as unknown as { global?: unknown }).global) {
  (window as unknown as { global: unknown }).global = window;
}

installAuthFetchInterceptor();

const recaptchaSiteKey = getRecaptchaSiteKey();

const appTree = recaptchaSiteKey ? (
  <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
    <App />
  </GoogleReCaptchaProvider>
) : (
  <App />
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {appTree}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
